<template>
  <div id="multiple-uploader" class="multiple-uploader-container">
    <input
      ref="refInputMulti"
      type="file"
      class="d-none"
      accept="image/*"
      multiple
      @change="onChangeImage"
    />

    <div class="uploader-wrp">
      <div class="row mb-1">
        <div class="col-12">
          <div class="font-medium-4">
            อัปโหลดภาพจำนวน
            {{
              imageList.filter((o) => {
                return o.image_url !== null;
              }).length
            }}/10
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="d-inline-block">
            <div
              v-for="(item, index) in imageList"
              :key="index + 'oop'"
              class="image-select-wrp d-inline-block mr-2 mb-1"
            >
              <div
                v-if="item.image_url"
                class="image-content-wrp position-relative"
              >
                <b-button
                  class="p-0 image-size"
                  variant="outline-light"
                  @click="openImage(item.image_url)"
                >
                  <img
                    class="h-100 w-100 obj-fit-cover image-border"
                    :src="item.image_url"
                  />
                </b-button>
                <div class="position-absolute top-0 right-0">
                  <b-button
                    variant="gradient-danger"
                    class="btn-icon rounded-circle btn-xs"
                    @click="onRemoveImage(item)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                </div>
              </div>
            </div>

            <div
              v-if="imageList.length < 10"
              class="add-image-btn-wrp d-inline-block"
            >
              <b-button class="image-size" variant="light" @click="onUpload">
                <img width="35" src="~@/assets/images/icons/addimage.png" />
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import UploadIcon from "@/@core/components/svg/button/Upload.vue";
import { ref } from "@vue/composition-api";
import useImageMultipleUploader from "../../hooks/useImageMultipleUpload";

export default {
  components: { BButton, UploadIcon },

  props: {
    imageDataList: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  setup(props) {
    const {
      imageList,
      onUpload,
      onChangeImage,
      openImage,
      onRemoveImage,
    } = useImageMultipleUploader(props);

    return {
      imageList,
      onUpload,
      onChangeImage,
      openImage,
      onRemoveImage,
    };
  },
};
</script>

<style></style>

<style scoped>
@import "~@/assets/css/override-styles/image-multiple-uploader.css";
</style>
